module.exports = __webpack_public_path__ + "static/media/spider6.2733ae0a.jpg";